import React from 'react';
import PropTypes from 'prop-types';
import './ExplanationStep.css';

/**
 * BusinessExplanationStep Component
 *
 * Explains what the business assessment evaluates before starting questions.
 */
const BusinessExplanationStep = ({ onNext, onPrev }) => {
  return (
    <div className="explanation-step">
      <div className="explanation-container">
        <h1 className="explanation-title">Business Assessment</h1>

        <p className="explanation-intro">
          The next 13 questions evaluate your business readiness for exit across critical value drivers.
        </p>

        <div className="explanation-content">
          <h2>What We'll Assess</h2>

          <div className="explanation-grid">
            <div className="explanation-card">
              <h3>Financial Performance</h3>
              <p>Revenue quality, growth trends, profitability, and financial documentation</p>
            </div>

            <div className="explanation-card">
              <h3>Management & Operations</h3>
              <p>Independence from owner, team strength, roles clarity, and scalability</p>
            </div>

            <div className="explanation-card">
              <h3>Customer Relationships</h3>
              <p>Retention, diversification, concentration risk, and relationship strength</p>
            </div>

            <div className="explanation-card">
              <h3>Competitive Position</h3>
              <p>Market positioning, intellectual property, strategic advantages, and growth potential</p>
            </div>

            <div className="explanation-card">
              <h3>Systems & Documentation</h3>
              <p>Process documentation, legal compliance, and transferability</p>
            </div>
          </div>

          <div className="explanation-how-it-works">
            <h2>How It Works</h2>
            <ul>
              <li><strong>Rate each question</strong> on a scale of 1-6 based on how your business compares to industry standards</li>
              <li><strong>Read the guidance</strong> provided for each question - click the 💡 Rule of Thumb and 📋 Why This Matters sections</li>
              <li><strong>Be honest</strong> - accurate responses lead to actionable insights</li>
              <li><strong>Questions auto-save</strong> - you can pause and return anytime</li>
            </ul>
          </div>

          <div className="explanation-note">
            <strong>⏱️ Time Required:</strong> Approximately 4-6 minutes for 13 questions
          </div>
        </div>

        <div className="explanation-actions">
          <button onClick={onPrev} className="btn-secondary">
            ← Back
          </button>
          <button onClick={onNext} className="btn-primary">
            Start Business Assessment →
          </button>
        </div>

        {/* Copyright Footer */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <div className="assessment-footer">
            © 2025 Dominion Business Advisors LLC. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

BusinessExplanationStep.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired
};

export default BusinessExplanationStep;
